import { Environment } from '../../helpers/create-store';
import { getEnv } from '../../helpers/mobx-easy-wrapper';

const AUTH_ROUTES = [
  '/login',
  '/register',
  '/confirm',
  '/forget-password',
  '/reset-password',
];

export const INITIAL_URL_KEY = 'initialUrl';

class UiStore {
  initialUrl?: string;

  constructor() {
    const initialUrl = localStorage.getItem(INITIAL_URL_KEY);
    this.initialUrl = initialUrl?.replace('#', '');
  }

  get env(): Environment {
    const { envConfig } = getEnv();
    return envConfig;
  }

  saveRedirectUrl(): void {
    const path = window.location.pathname;
    const isAuthRoute = AUTH_ROUTES.some(
      (r) => path === r || path.startsWith(`${r}/`)
    );

    if (isAuthRoute || path === '/') {
      return;
    }

    const fullPath = path + window.location.search;
    localStorage.setItem(INITIAL_URL_KEY, fullPath);
    this.initialUrl = fullPath;
  }

  getAndClearRedirectUrl(): string | null {
    const redirectUrl = localStorage.getItem(INITIAL_URL_KEY);
    if (!redirectUrl) {
      return null;
    }

    localStorage.removeItem(INITIAL_URL_KEY);
    this.initialUrl = undefined;
    return redirectUrl;
  }
}

export default UiStore;
